import React, { useContext } from 'react';
import { Context } from './app';

function Message() {

    let appContex = useContext(Context);
    let user = appContex.user;

    return (
        <React.Fragment>
            <div className="page-container">
                <div className="bg-white border-rounded m-2 p-5">
                    <label className="text-primary">Dear {user.user_name},</label>
                    <p>
                        You have Zero Active Sites at this moment.
                        <br />So, you can only navigate through non-site specific functionalities.
                        <br /><br />If you feel, this is an issue, please get in touch with SiteSupt Support.
                    </p>
                </div>
            </div>
        </React.Fragment>
    );
}

export default Message;